<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form size="small">
      <div class="operation-wrap">
        <p>配置说明：</p>
        <p>1. 推送标题与内容可使用下方字段占位，保存后在「消息通知」列表中启用 APP 推送。</p>
        <p>2. 实际下发以站内信写入时的标题/内容为准；此处模板供运营记录变量映射。</p>
      </div>
      <el-form-item label="推送标题">
        <el-input v-model="pushTitle" class="max-w460" placeholder="如：订单支付成功" />
      </el-form-item>
      <el-form-item label="推送内容">
        <el-input v-model="pushContent" type="textarea" :rows="3" class="max-w460" placeholder="如：您的订单{order_no}已支付成功" />
      </el-form-item>
      <div class="table-wrap">
        <el-table border ref="fieldTable" :data="fieldList" @selection-change="handleSelectionChange" v-loading="loading">
          <el-table-column type="selection" width="55" />
          <el-table-column label="字段名称">
            <template slot-scope="scope">
              <label>{{ scope.row.field_name }}</label>
            </template>
          </el-table-column>
          <el-table-column label="模板变量名">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.field_new_ename" />
            </template>
          </el-table-column>
          <el-table-column label="示例值">
            <template slot-scope="scope">
              <el-input size="small" :disabled="scope.row.is_var === 1" v-model="scope.row.filed_new_value" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="saveTemplate" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MessageApi from '@/api/message.js'

export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      fieldList: [],
      title: '设置 APP 推送模板',
      checkList: [],
      settings: {},
      pushTitle: '',
      pushContent: '',
    }
  },
  props: ['open_app_push', 'messageModel'],
  created() {
    this.dialogVisible = this.open_app_push
    this.title = this.title + '(' + this.messageModel.message_name + ')'
    this.getData()
  },
  methods: {
    getData() {
      const self = this
      self.loading = true
      MessageApi.fieldList({
        message_id: self.messageModel.message_id,
        message_type: 'app_push',
      }, true)
        .then(data => {
          data.data.list.forEach(field => {
            field.field_new_ename = field.field_ename
            field.filed_new_value = field.filed_value
          })
          self.fieldList = data.data.list
          if (data.data.settings == null || data.data.settings.length === 0) {
            self.settings = {}
            self.pushTitle = ''
            self.pushContent = ''
          } else {
            self.settings = data.data.settings
            self.pushTitle = data.data.settings.title || ''
            self.pushContent = data.data.settings.content || ''
          }
          self.loading = false
          self.$nextTick(() => {
            self.initChecked()
          })
        })
        .catch(() => {
          self.loading = false
        })
    },
    saveTemplate() {
      const self = this
      self.loading = true
      MessageApi.saveSettings({
        fieldList: self.checkList,
        message_id: self.messageModel.message_id,
        message_type: 'app_push',
        title: self.pushTitle,
        content: self.pushContent,
      }).then(() => {
        self.loading = false
        self.$message({ message: '保存成功', type: 'success' })
        self.dialogFormVisible(true)
      }).catch(() => {
        self.loading = false
      })
    },
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', { type: 'success', openDialog: false })
      } else {
        this.$emit('closeDialog', { type: 'error', openDialog: false })
      }
    },
    handleSelectionChange(val) {
      this.checkList = val
    },
    initChecked() {
      const self = this
      if (JSON.stringify(self.settings) === '{}' || !self.settings.var_data) {
        return
      }
      Object.keys(self.settings.var_data).forEach(key => {
        self.fieldList.forEach(field => {
          if (field.field_ename === key) {
            self.$refs.fieldTable.toggleRowSelection(field, true)
            field.field_new_ename = self.settings.var_data[key].field_name
            field.filed_new_value = self.settings.var_data[key].filed_value
          }
        })
      })
    },
  },
}
</script>

<style scoped>
.max-w460 {
  max-width: 460px;
}
.operation-wrap {
  margin-bottom: 12px;
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/message/settings/AppPush.vue